import {ROOT_OBJECTIONS,CALLBACK_ROOTS} from './data.ts'
import {V9_LEGACY_ALIASES} from './v9-source.ts'
import type {ConversationAction} from './reducer.ts'

const purposes=new Set([...ROOT_OBJECTIONS.flatMap(group=>group.ids),...Object.values(CALLBACK_ROOTS)])
export const PURPOSE_VARIANTS:Readonly<Record<string,string>>={'OBJ-DISCOUNT':'same-scope-discount','OBJ-ROI':'roi-guarantee','OBJ-REFERRALS':'referral-channel','OBJ-ALREADY-COVERED':'coverage-comparison'}
/** A selected reason is a category; its displayed title is never a supplied answer. */
export function purposeEntry(purpose:string,concern=''):Extract<ConversationAction,{type:'interrupt'}> {
  if(!purposes.has(purpose))return {type:'interrupt',id:purpose,concern}
  return {type:'interrupt',id:purpose==='OBJ-CANCEL'?'F20':V9_LEGACY_ALIASES[purpose]??purpose,concern,purpose}
}
